export class PageList {
  constructor() {
    this.tableData = [];
    this.queryInfo = {
      query: {},
      queryInfoClear: () => {},
      searchList: () => {},
      isActive: false,
      onActive: () => {
        this.queryInfo.isActive = !this.queryInfo.isActive;
      },
    };
    this.page = {
      pageNum: 1,
      pageSize: 10,
    };
    this.pagination = {
      pageSize: this.page.pageSize,
      currentPage: this.page.pageNum,
      pageSizes: [5, 10, 20, 50, 100, 200],
      layout: "total, sizes, prev, pager, next, jumper",
      total: 0,
      sizeChange: (pageSize) => {
        console.log("sizeChange", pageSize);
        this.page.pageSize = pageSize;
        this.queryInfo.searchList();
      },
      currentChange: (pageNum) => {
        console.log("currentChange", pageNum);
        this.page.pageNum = pageNum;
        this.queryInfo.searchList();
      },
    };
  }
  update(res) {
    if (res.code === 200) {
      const { data = {} } = res;
      this.tableData = data.list;
      this.pagination.total = data.total;
    }
  }
}

import axios from "axios";
export class CreatedUrl {
  static openUrl = (url, filename) => {
    fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(blobUrl);
          document.body.removeChild(a);
        })
        .catch(error => console.error('Download failed:', error));
    // const a = document.createElement("a");
    // a.target = "_bank";
    // a.style.display = "none"; //隐藏,没必要展示出来
    // url = url.replace('http:','https:')
    // a.href = url;
    // document.body.appendChild(a);
    // a.click();
    // URL.revokeObjectURL(a.href); // 释放URL 对象
    // document.body.removeChild(a); //完成移除
  };
  static bolbDown = (_blob, name) => {
    const nowTimer = new Date().getTime();
    const blob = new Blob([_blob]); //处理文档流
    const fileName = nowTimer + name;
    const a = document.createElement("a");
    a.download = fileName;
    //a.setAttribute("download", fileName); //下载的文件名以及文件格式
    a.target = "_bank";
    a.style.display = "none"; //隐藏,没必要展示出来
    a.href = URL.createObjectURL(blob);

    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(a.href); // 释放URL 对象
    document.body.removeChild(a); //下载完成移除
  };
  static urlDown = async (url, name) => {
    const axiosService = axios.create({
      timeout: 60000, // 请求超时时间
      // withCredentials: false,
    });
    axiosService({
      method: "get",
      url: url,
      responseType: "blob",
      ["headers.Authorization"]: "",
    }).then((res) => {
      this.bolbDown(res.data, name);
    });
  };
}
